export default __webpack_public_path__ + "static/media/chooseYourself_ua_d.c4f44972.svg";